import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const homeStreamPackagesCard = style([
  {
    display: 'flex',
    justifyContent: 'space-between',
    gap: space.s16,
    backgroundColor: themeVars.color.bg.brand.default,
    padding: space.s24,
    paddingRight: 0,
    borderRadius: borderRadius.r12,
    border: `1px solid ${themeVars.container.border.secondary}`,
  },
  responsiveStyle({
    mobile: {
      flexDirection: 'column',
    },
    tablet: {
      flexDirection: 'row',
    },
  }),
]);

export const homeCardLeftContainer = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s16,
    color: themeVars.color.text.inverse,
  },
  responsiveStyle({
    mobile: {
      width: '100%',
    },
    tablet: {
      width: '50%',
    },
  }),
]);

export const homeStreamPackagesHeader = style([
  typography.bodySm,
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s2,
  },
]);

export const homeStreamPackagesHeaderText = style([
  typography.bodySm,
  {
    color: themeVars.color.bg.inverse.active,
  },
]);

export const homeStreamPackagesTitle = style([
  typography.titleLg,
  {
    marginBottom: space.s8,
  },
]);

export const homeStreamPackagesDescription = style([
  typography.bodyMd,
  {
    color: themeVars.color.bg.inverse.hover,
  },
]);

export const homeExploreButton = style([
  {
    marginTop: 'auto',
    width: 'fit-content',
  },
]);

export const homeStreamPackagesImageContainer = style([
  {
    position: 'relative',
    overflow: 'hidden',
    height: 'fit-content',
    alignSelf: 'center',
  },
  responsiveStyle({
    mobile: {
      width: '100%',
    },
    tablet: {
      width: '50%',
    },
  }),
]);

export const homeStreamPackagesImage = style([
  {
    width: 641,
  },
]);

export const homeGradientBlock = style([
  {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: space.s4,
    width: 100,
    background: `linear-gradient(to right, transparent, ${themeVars.color.bg.brand.hover})`,
  },
]);
